import { ReactNode, FC } from 'react';
import { SkeletonLoader } from '@frontend/design-system';
import { loaderContainerStyle } from './task-skeleton-loaders.style';

interface SkeletonLoaderProps {
  children: ReactNode;
  isLoading?: boolean;
}

export const TitleSkeletonLoader: FC<SkeletonLoaderProps> = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <div css={loaderContainerStyle} id='task-title-skeleton-loader'>
        <SkeletonLoader width='100%' height={20} />
        <SkeletonLoader width='70%' height={20} />
      </div>
    );
  }

  return <>{children}</>;
};

export const DescriptionSkeletonLoader: FC<SkeletonLoaderProps> = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <div css={loaderContainerStyle}>
        <SkeletonLoader width='100%' height={20} />
        <SkeletonLoader width='90%' height={20} />
        <SkeletonLoader width='100%' height={20} />
        <SkeletonLoader width='70%' height={20} />
      </div>
    );
  }
  return <>{children}</>;
};
